import { NgModule } from '@angular/core';
import { MediumShopComponent } from '~shared/svgs/medium-shop/medium-shop.component';

@NgModule({
  declarations: [
    MediumShopComponent
  ],
  exports: [
    MediumShopComponent
  ]
})
export class MediumShop {}
